import { types } from "../../types/types"

const initialState = {
    formulariosMiOspedyc: null,
    formulariosPorCategoriaMiOspedyc: null,
    categoriasFormularios: null,
    loading: false
}

export const abmFormulariosMiOspedycReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.get_formularios_mi_ospedyc:
            return {
                ...state,
                loading: true,
            }
        case types.get_formularios_mi_ospedyc_success:
            return {
                ...state,
                formulariosMiOspedyc: action.payload,
                loading: false,
            }
        case types.get_formularios_mi_ospedyc_failure:
            return {
                ...state,
                loading: false,
                formulariosMiOspedyc: []
            }
            
        case types.get_formulariosporcategoria_mi_ospedyc:
            return {
                ...state,
                loading: true,
            }
        case types.get_formulariosporcategoria_mi_ospedyc_success:
            return {
                ...state,
                formulariosPorCategoriaMiOspedyc: action.payload,
                loading: false,
            }
        case types.get_formulariosporcategoria_mi_ospedyc_failure:
            return {
                ...state,
                loading: false,
                formulariosPorCategoriaMiOspedyc: []
            }
        case types.get_categorias_formularios:
            return {
                ...state,
                loading: true,
            }
        case types.get_categorias_formularios_success:
            return {
                ...state,
                categoriasFormularios: action.payload,
                loading: false,
            }
        case types.get_categorias_formularios_failure:
            return {
                ...state,
                loading: false,
                categoriasFormularios: []
            }
        default:
            return state;
    }
}